import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

const app = createApp(App)

app.config.globalProperties.$downloadClient = function () {
  const downloadUrl = "https://www.quickmatrixtool.com/download";
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = "QuickMatrix.exe";
  link.rel = "noopener";
  // Firefox 要求 a 节点必须挂在 DOM 上才能触发 click
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

app.use(router);
app.mount('#app');
